import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import moment from "moment";

import apiCall from "../../helpers/apifactory";

const Rates = (query) => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        .scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classNameList.add('fixed-header-desktop') : document.querySelector("nav").classNameList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false
  );
  const [rateteriff, setRateteriff] = useState();
  const [transits, setTransits] = useState();
  const [originState, setOriginState] = useState("");
  let [searchParams, setSearchParams] = useSearchParams();

  const transdate = searchParams.get("transdate");
  const weight = searchParams.get("weight");
  const origin = searchParams.get("origin");
  const dstn = searchParams.get("dstn");

  console.log(transdate, weight, origin, dstn);

  const param = {
    transdate: moment(transdate, "DD/MM/YYYY").format("DD/MM/YYYY"),
    weight: weight,
    // origin: origin.split('-')[0],
    origin: origin.split("-")[0],
    // dstn: destination,
    dstn: dstn.split("-")[0],
    postal: "0000",
  };

  useEffect(() => {
    getFare();
  }, []);

  const getFare = () => {
    const body = {
      origincode: param?.origin,
      destinationcode: param?.dstn,
      weight: param?.weight,
    };
    apiCall
      .getTarif(body, {})
      .then((res) => {
        setRateteriff(res?.data?.responseData?.data);
      })
      .catch((error) => {
        // console.log("===============", error);
      });
  };

  const rateteriffApi = async (param) => {
    apiCall
      .rateteriffApi(param)
      .then((d) => {
        const { IsSuccess, Data } = d.data;
        console.log("===========", Data);
        if (IsSuccess) {
          // setRateteriff(Data[0].tariffs);
          setTransits(Data[0].transits);
        } else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">Rate Calculator</h1>
      </div>

      <div className=" flex justify-center items-center my-[3rem]">
        <div className="w-[60rem] flex flex-col justify-center  ">
          <h1 className="text-3xl font-bold mb-3 ">Rates</h1>
          <table className="mt-6">
            <thead>
              <tr className="text-left text-sm text-gray-800 bg-gray-100">
                <th className="border p-2">Service</th>
                <th className="border p-2">Service Charges</th>
                <th className="border p-2">Fuel Surcharges</th>
                <th className="border p-2">GST Amount</th>
                <th className="border p-2">Total Amount</th>
                {/* <th className="border p-2">Amount (Rs)</th> */}
              </tr>
            </thead>
            <tbody>
              {rateteriff?.length &&
                rateteriff.map((data, index) => (
                  <tr key={index} className="text-sm text-gray-800">
                    <td className="border p-2">{data.title}</td>
                    <td className="border p-2">{data.servicecharges}</td>
                    <td className="border p-2">{data.fuelcharges}</td>
                    {/* <td className="border p-2">{'dsafd'}</td> */}
                    <td className="border p-2">{data.gstrate}</td>
                    <td className="border p-2">{data.totalamount}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          {transits && transits.length !== 0 && (
            <>
              <h1 className="text-3xl font-bold mt-8 mb-3 ">Transit</h1>
              <table className="mt-6">
                <thead>
                  <tr className="text-left text-sm text-gray-800 bg-gray-100">
                    <th className="border p-2">Service</th>
                    <th className="border p-2">Transit Days</th>
                    <th className="border p-2">Pickup Date</th>
                    <th className="border p-2">Pickup Time</th>
                    <th className="border p-2">Arrival Date</th>
                    <th className="border p-2">Arrival Time</th>
                    {/* <th className="border p-2">Delivery Time Frame</th> */}
                  </tr>
                </thead>
                <tbody>
                  {transits.map((transit) => (
                    <tr
                      className="text-sm text-gray-800"
                      key={transit.serviceCode}
                    >
                      <td className="border p-2">{transit.title}</td>
                      <td className="border p-2">{transit.transitDays}</td>
                      <td className="border p-2">{transdate}</td>
                      <td className="border p-2">{transit.originDeparture}</td>
                      <td className="border p-2">{transit.deliveryDate}</td>
                      <td className="border p-2">{transit.deliveryTime}</td>
                      <td className="border p-2">
                        {transit.deliveryTimeFrame}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default Rates;
